// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React from "react";

import * as Env from "../Env";

const ExperimentsServiceContext = React.createContext<{
  experimentAssignments: Record<string, string>;
  osEnv: string;
}>({
  experimentAssignments: {},
  osEnv: "",
});

export const ExperimentsServiceProvider: React.FC<
  React.PropsWithChildren<{}>
> = ({ children }) => {
  return (
    <ExperimentsServiceContext.Provider
      value={{
        experimentAssignments: Env.EXPERIMENT_ASSIGNMENTS,
        osEnv: Env.OUTSCHOOL_ENV,
      }}
    >
      {children}
    </ExperimentsServiceContext.Provider>
  );
};

export function useServerExperimentContext() {
  return React.useContext(ExperimentsServiceContext);
}
